export interface ThemeColor {
	name: string;
	color: {
		value: string;
	};
}

type Color = ThemeColor;

const setColors = (colors: Color[]) => {
	const root = document?.documentElement;

	(colors || []).forEach((color: Color) => {
		root?.style?.setProperty(`--${color.name}`, color.color.value);
	});
};

export default setColors;
